import type { Ohaeng, ElementRelation } from '../types/elements';
import type { HeavenlyStem } from '../types/stems';
import type { EarthlyBranch } from '../types/branches';
import { STEM_ELEMENT, BRANCH_ELEMENT } from './constants';

// 상생 관계: 木→火→土→金→水→木
const GENERATING: Record<Ohaeng, Ohaeng> = {
  '木': '火', '火': '土', '土': '金', '金': '水', '水': '木',
};

// 상극 관계: 木→土→水→火→金→木
const OVERCOMING: Record<Ohaeng, Ohaeng> = {
  '木': '土', '土': '水', '水': '火', '火': '金', '金': '木',
};

/** 오행의 상생·상극 관계를 반환한다 */
export function getElementRelation(element: Ohaeng): ElementRelation {
  const generates = GENERATING[element];
  const overcomes = OVERCOMING[element];
  // Find what generates this element
  const generatedBy = (Object.entries(GENERATING) as [Ohaeng, Ohaeng][])
    .find(([, v]) => v === element)![0];
  // Find what overcomes this element
  const overcomeBy = (Object.entries(OVERCOMING) as [Ohaeng, Ohaeng][])
    .find(([, v]) => v === element)![0];
  return { generates, overcomes, generatedBy, overcomeBy };
}

/** 천간의 오행을 반환한다 */
export function getStemElement(stem: HeavenlyStem): Ohaeng {
  return STEM_ELEMENT[stem];
}

/** 지지의 오행을 반환한다 */
export function getBranchElement(branch: EarthlyBranch): Ohaeng {
  return BRANCH_ELEMENT[branch];
}

/** A 오행이 B 오행을 극하는지 확인한다 (상극) */
export function isOvercoming(a: Ohaeng, b: Ohaeng): boolean {
  return OVERCOMING[a] === b;
}

/**
 * A 오행 기준으로 B 오행과의 관계를 반환한다 (십신 계산용).
 *
 * - 'same': 동일 오행
 * - 'generates': A가 B를 생함
 * - 'generated': B가 A를 생함
 * - 'overcomes': A가 B를 극함
 * - 'overcome': B가 A를 극함
 */
export function getElementRelationship(a: Ohaeng, b: Ohaeng): 'same' | 'generates' | 'generated' | 'overcomes' | 'overcome' {
  if (a === b) return 'same';
  if (GENERATING[a] === b) return 'generates';
  if (GENERATING[b] === a) return 'generated';
  if (OVERCOMING[a] === b) return 'overcomes';
  return 'overcome';
}
